import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SanitizeType } from '../../types/common.types';

/**
 * safe pipe sanitize the content to be safe in the given context.
 * it will strip unsafe content if necessary.
 * useful to sanitize unsafe values such as unsafe URLs and user input.
 * @see https://angular.io/api/platform-browser/DomSanitizer
 */

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
    this.sanitizer = sanitizer;
  }

  transform(content: string, type: SanitizeType): string | null {
    const sanitizeType = {
      none: SecurityContext.NONE,
      html: SecurityContext.HTML,
      style: SecurityContext.STYLE,
      script: SecurityContext.SCRIPT,
      url: SecurityContext.URL,
      resourceUrl: SecurityContext.RESOURCE_URL
    };

    /** switch (type) {
      case 'none':
        return this.sanitizer.sanitize(SecurityContext.NONE, content);
      case 'html':
        return this.sanitizer.sanitize(SecurityContext.HTML, content);
      case 'style':
        return this.sanitizer.sanitize(SecurityContext.STYLE, content);
      case 'script':
        return this.sanitizer.sanitize(SecurityContext.SCRIPT, content);
      case 'url':
        return this.sanitizer.sanitize(SecurityContext.URL, content);
      case 'resourceUrl':
        return this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, content);
      default:
        return '';
    }*/
    const selectedType = sanitizeType[type];
    return selectedType ? this.sanitizer.sanitize(selectedType, content) : '';
  }
}
